import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL ?? '/api/v1';

const client = axios.create({ baseURL: API_URL, timeout: 15_000 });

type Envelope<T> = { data: T };

export type VerifyView = {
  id: string;
  title: string;
  status: string;
  workflow: string;
  organizationName: string;
  sentAt: string | null;
  completedAt: string | null;
  documents: Array<{
    id: string;
    name: string;
    pages: number;
    originalSha256: string;
    signedSha256: string | null;
    uploadedAt: string;
  }>;
  recipients: Array<{
    id: string;
    name: string;
    email: string;
    role: string;
    signingOrder: number;
    status: string;
    signedAt: string | null;
    declinedAt: string | null;
  }>;
};

export type HashCheckResult =
  | { match: true; document: { id: string; name: string; kind: 'original' | 'signed' } }
  | { match: false; error?: string };

export const verifyApi = {
  async get(uuid: string): Promise<VerifyView> {
    const { data } = await client.get<Envelope<VerifyView>>(`/verify/${uuid}`);
    return data.data;
  },

  async checkHash(uuid: string, hash: string): Promise<HashCheckResult> {
    const { data } = await client.post<Envelope<HashCheckResult>>(
      `/verify/${uuid}/check-hash`,
      { hash },
    );
    return data.data;
  },
};
